import { ListGroupItem } from 'components/shared/ListGroup';
import type { IntlKey } from 'locales';

type LabelDetailsItemProps = { label: IntlKey; value: string; e2e: string };
export function LabelDetailsItem({ label, value, e2e }: LabelDetailsItemProps) {
  return (
    <ListGroupItem className="ps-0 pe-3 text-nowrap" labelKey={label} data-e2e={e2e}>
      <span data-e2e={`${e2e}-value`} className="ms-3 text-truncate" title={value}>
        {value}
      </span>
    </ListGroupItem>
  );
}
